<script setup lang="ts">
const appStore = useAppStore()
const { format } = useFormatAmount()
const { cartRoute } = useMcdRoutes()
const { trackGoCart } = useGTM()

const cartProductsLength = computed(() =>
  appStore.cart.products.reduce((acc, product) => acc + product.unit, 0)
)

const openCart = async () => {
  trackGoCart()
  await navigateTo(cartRoute())
}
</script>

<template>
  <section data-test="cart-bag" class="fixed bottom-20 z-10 w-full px-4">
    <div
      class="flex w-full flex-row items-center rounded-full bg-mcd-black px-4 py-3"
      @click="openCart"
    >
      <div class="flex flex-1 flex-row items-center gap-4">
        <div id="onboarding-step-4" class="relative">
          <img
            src="/images/icons/mcd-bag.svg"
            class="block max-h-[2rem] min-h-[2rem] min-w-[2rem] max-w-[2rem]"
            alt="cart"
          />
          <div
            class="absolute -right-2 -top-1 grid h-5 w-5 place-content-center rounded-full border-2 border-mcd-black bg-mcd-secondary p-[1px] text-xs"
          >
            <span>{{ cartProductsLength }}</span>
          </div>
        </div>
        <p class="text-lg font-bold text-white">{{ format(appStore.cartTotal) }}</p>
      </div>
      <Chevron fill="#FFFFFF" class="h-6 w-6 cursor-pointer justify-end" />
    </div>
  </section>
</template>
